export const FONTS = {
    TITLE: 'Sora',
    SUBTITLE: 'Karla',
};
